export { PickUpItemsFeature } from './pickup-items';
